import { Auth0Provider } from '@auth0/auth0-react';
import { auth0Config, AUTH_SCOPES } from '@feature/auth/constants/auth.constants';
import { AuthInterceptorProvider } from '@shared/providers/AuthInterceptorProvider';
import { UserProfileProvider } from '@feature/auth/contexts/UserProfileContext';

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/callback`,
        audience: auth0Config.audience,
        scope: AUTH_SCOPES
      }}
      // Persistencia tras refresh; renovación silenciosa vía iframe (prompt=none), sin offline_access
      cacheLocation="localstorage"
      useRefreshTokens={false}
      onRedirectCallback={(appState) => {
        if (appState?.returnTo) {
          sessionStorage.setItem('auth_redirect_return_to', appState.returnTo);
        }
      }}
    >
      <AuthInterceptorProvider>
        <UserProfileProvider>
          {children}
        </UserProfileProvider>
      </AuthInterceptorProvider>
    </Auth0Provider>
  );
}; 